import NotificationTopicService from "@/services/notificationTopic";

export default {
  namespaced: true,
  state: {
    apiKey: [],
  },

  getters: {
    async getNotificationTopics({ commit, state, getters, dispatch }) {
      try {
        const response = await NotificationTopicService.getNotificationTopics();
        return response.data && response.data.attributes
          ? response.data.attributes
          : [];
      } catch (e) {
        console.log(e);
      }
    },
  },

  actions: {
    async storeNotificationTopic(
      { commit, state, getters, dispatch },
      payload
    ) {
      try {
        const response = await NotificationTopicService.storeNotificationTopic(
          payload
        );
        return response.data && response.data.attributes
          ? response.data.attributes
          : {};
      } catch (e) {
        console.log(e);
      }
    },
    async updateNotificationTopic(
      { commit, state, getters, dispatch },
      payload
    ) {
      try {
        const response = await NotificationTopicService.updateNotificationTopic(
          payload.id,
          payload
        );
        return response.data && response.data.attributes
          ? response.data.attributes
          : {};
      } catch (e) {
        console.log(e);
      }
    },
    async deleteNotificationTopic({ commit, state, getters, dispatch }, id) {
      try {
        await NotificationTopicService.deleteNotificationTopic(id);
        return true;
      } catch (e) {
        console.log(e);
      }
    },
  },

  mutations: {},
};
